import { ChangeDetectionStrategy, Component, Input, OnDestroy, Pipe } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { CrimeGunService } from 'src/app/services/crime-gun.service';
import { AppPermissions } from 'src/app/shared/app.permissions';
import { AuthorizationModel } from 'src/app/shared/models/authorization-model';
import { UtcToLocalPipe } from 'src/app/shared/pipes/utc-to-local.pipe';
import { TextInputModel } from '../../../shared/models/text-input.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ness-crime-gun-data',
  templateUrl: './crime-gun-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./crime-gun-data.component.scss'],
  providers: [UtcToLocalPipe]
})
export class CrimeGunDataComponent implements OnDestroy {

  private _crimeGunFirearm: ServerModels.CrimeGunFirearm = null;
  public get crimeGunFirearm(): ServerModels.CrimeGunFirearm {
    return this._crimeGunFirearm;
  }

  pipe = new DatePipe('en-US');

  @Input() public set crimeGunFirearm(firearm: ServerModels.CrimeGunFirearm) {
    this._crimeGunFirearm = firearm;
    if (firearm) {
      this.textInputModel.dataValue = firearm.LegacyATFGunNumber;
      this.textInputModelSubject.next(this.textInputModel);
      if (this.authService.userType === 'StateLocalLE' && !this.authService.hasRole(['NESS Administrator'])) {
        if (this._crimeGunFirearm?.TriageLevelName === 'N/A') {
          this.mostRecentTriageDataForUser = `My Agency's Most Recent Triage: N/A`;
        }
        else {
            this.mostRecentTriageDataForUser = `My Agency's Most Recent Triage: ${this._crimeGunFirearm?.TriageLevelName}; ${this.pipe.transform(this._crimeGunFirearm?.MostRecentTriageDate, 'MM/dd/yyyy', 'UTC')}`;
        }
      } else {
        this.mostRecentTriageDataForUser = `Most Recent ATF Triage: ${this._crimeGunFirearm?.TriageLevelName}; ${this.pipe.transform(this._crimeGunFirearm?.MostRecentTriageDate, 'MM/dd/yyyy', 'UTC')}`;
      }
    }
  }
  @Input() canViewFTS: AuthorizationModel;
  @Input() canViewCrimeGun: AuthorizationModel;
  @Input() canEditCrimeGun: boolean;

  _unsubscribe$: Subject<void> = new Subject<void>();
  errorMessage: string = 'An error occurred.';
  displayErrorStatus: boolean = false;
  mostRecentTriageDataForUser: string = null;
  editGunId: boolean = false;
  textInputModel: TextInputModel = <TextInputModel>{
    dataValue: null,
    label: 'Legacy Gun ID(s)',
    id: 'legacyGunIdTxt',
    disabled: false,
    stringLength: 80,
    saveButtonAriaLabel: 'Save legacy gun id changes.',
    cancelButtonAriaLabel: 'Cancel legacy gun id changes.',
    editButtonAriaLabel: 'Edit legacy gun id(s).'
  };

  readonly isStateLocalUser = this.authService.hasUserType(['StateLocalLE']);

  readonly ttfsTooltip = this.isStateLocalUser ? 'TTFS is the number of days between the last known retail firearm purchase (eTrace) or theft (if reported stolen) and the first shooting event. Please reach out to the agency who recovered the firearm for trace details, using the FTS ID listed above.'
    : 'TTFS is the number of days between the last known retail firearm purchase (eTrace) or theft (if reported stolen) and the first shooting event.';

  private textInputModelSubject = new BehaviorSubject<TextInputModel>(this.textInputModel);
  textInputModel$: Observable<TextInputModel> = this.textInputModelSubject.asObservable();

  constructor(public messageService: MessageService,
    private authService: AuthService,
    private crimeGunService: CrimeGunService,
    private utcToLocalPipe: UtcToLocalPipe) { }

  ngOnDestroy() {
    this.messageService.clear();
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  onLegacyATFGunNumberSave(data: string) {
    this.errorMessage = '';
    this.displayErrorStatus = false;
    if (this._crimeGunFirearm.LegacyATFGunNumber !== data) {
      this._crimeGunFirearm.LegacyATFGunNumber = data;
      this.crimeGunService.addOrUpdateLegacyATFGunNumber(this._crimeGunFirearm).subscribe({
        next: null,
        error: (err: any) => {
          this.errorMessage = err;
          this.displayErrorStatus = true;
        },
        complete: null
      });
    }
  }
}
